<template>
  <v-row class="dashboard">
    <v-col
      cols="12"
      md="12"
    >
      <dashboard-statistics-card></dashboard-statistics-card>
    </v-col>
    <v-col
      v-if="can('statistics-list')"
      cols="12"
      md="4"
    >
      <dashboard-card-total-earning />
    </v-col>
    <v-col
      v-if="can('statistics-list')"
      cols="12"
      md="8"
    >
      <monthly-earning />
    </v-col>
    <v-col cols="12">
      <main-meter-readings />
    </v-col>
    <v-col cols="12">
      <faulty-meters />
    </v-col>
  </v-row>
</template>

<script>

import DashboardStatisticsCard from './DashboardStatisticsCard.vue'
import DashboardCardTotalEarning from './TotalRevenueCurrentMonthCard.vue'
import MonthlyEarning from './MonthlyRevenueCard.vue'
import MainMeterReadings from './MainMeterReadings.vue'
import FaultyMeters from './FaultyMetersCard.vue'
import hasPermission from '@/mixins/hasPermission'

export default {
  components: {
    DashboardStatisticsCard,
    DashboardCardTotalEarning,
    MonthlyEarning,
    MainMeterReadings,
    FaultyMeters,
  },
  mixins: [hasPermission],
}
</script>

<style scoped>
.dashboard > .col-12 {
  min-width: 0;
}
</style>
